<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="t('modalsDeletePaymentTitle')"
      [showCloseButton]="false"
      [closeOnBackdropClick]="false"
      (closeModal)="onCancel()"
    >
      <div modal-content>
        <div class="py-1">
          <p class="font-dm text-sm text-ld-neutral-700 mb-4">{{ t('modalsDeletePaymentSelectReason') }}</p>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ t('commonSelectAReason') }}</mat-label>
            <mat-select [value]="selectedReason()" (selectionChange)="onReasonChange($event.value)">
              @for (reason of reasons; track reason.code) {
                <mat-option [value]="reason">{{ reason.description }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (isOtherReason()) {
            <mat-form-field appearance="outline" class="w-full mt-4">
              <mat-label>{{ t('modalsDeletePaymentPleaseSpecify') }}</mat-label>
              <textarea
                matInput
                rows="3"
                maxlength="22"
                [placeholder]="t('modalsDeletePaymentEnterReason')"
                [ngModel]="otherReasonText()"
                (ngModelChange)="onOtherReasonChange($event)"
              ></textarea>
            </mat-form-field>
          }

          @if (isFinancialHardship()) {
            <div class="mt-4 bg-amber-50 border border-amber-300 rounded-lg p-4">
              <div class="flex items-start gap-3">
                <img [src]="heroiconsWarning" alt="Warning" class="w-6 h-6 shrink-0" />
                <p class="font-dm text-sm text-amber-800">
                  {{ t('modalsDeletePaymentHardshipIntro') }}
                  <a
                    [href]="supportResourcesUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="font-medium underline hover:no-underline"
                  >
                    {{ t('paymentStatusBannerSupportResources') }}
                  </a>
                  {{ t('modalsDeletePaymentHardshipSendUs') }}
                  <a [routerLink]="['/messages', loanNumber()]" class="font-medium underline hover:no-underline">
                    {{ t('modalsDeletePaymentHardshipSecureMessage') }}
                  </a>
                  {{ t('modalsDeletePaymentHardshipContactSuffix') }}
                  <a
                    [href]="technicalSupportTel"
                    class="text-ld-link font-medium hover:underline cursor-pointer whitespace-nowrap"
                  >
                    {{ technicalSupportPhone }}
                  </a>
                  {{ t('modalsDeletePaymentHardshipContactSuffixPost') }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>

      <div modal-footer>
        <button type="button" class="btn-outline-ld-purple" [disabled]="isDeleting()" (click)="onCancel()">
          {{ t('commonButtonsCancel') }}
        </button>
        <button type="button" class="btn-solid-red" [disabled]="!canDelete() || isDeleting()" (click)="onDelete()">
          @if (isDeleting()) {
            <span class="flex items-center gap-2">
              <mat-icon class="animate-spin text-sm!">refresh</mat-icon>
              {{ t('commonDeleting') }}
            </span>
          } @else {
            {{ t('commonButtonsDelete') }}
          }
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
